@if(field){
<div class="file-container" [formGroup]="form">
  <div class="field-container" >
    <label class="field-label">{{ field.displayName | camelCase }}
      <span class="attachment-icon">
        <i class="fa-solid fa-paperclip"></i>
      </span>
    </label>
    <input type="file" id="file" (change)="onFileChange(field.fieldName,$event)" [formControlName]="field.fieldName"
      class="file-input" style="display: none;" #fileInput [multiple]="field.multiple" [ngClass]="(field['disabled'])? 'input-disabled': ''" />
    <div class="input-field-container">
      <div (click)="fileInput.click()" onkeydown="" class="input-field-element"  [ngClass]="(field['disabled'])? 'input-disabled': ''" >
        <span class="attachment-upload-btn" for="file"   [ngClass]="(field['disabled'])? 'input-disabled': ''" >Upload Files</span>
        <span class="file-count">
          @if((attachmentFiles | keyvalue).length === 0) {
          No files uploaded
          } @else if((attachmentFiles | keyvalue).length === 1) {
          1 file uploaded
          } @else {
          {{ (attachmentFiles | keyvalue).length }} files uploaded
          }
        </span>
      </div>

      @if((attachmentFiles | keyvalue).length > 0){
      <div class="selected-files">
        @for(file of attachmentFiles| keyvalue; track idx; let idx = $index){
        <div class="selected-file">
          <span class="file-label" [title]="file.value.name">{{ file.value.name }}</span>
          <span class="close-icon" (click)="clear(file.key)" onkeydown="" title="clear"><i
              class="fa-regular fa-circle-xmark"></i></span>
        </div>
        }
      </div>
      }

    </div>
  </div>
  <mat-error *ngIf="form.get(field.fieldName)?.hasError('required') && form.get(field.fieldName)?.touched">
    {{ field.displayName | camelCase }} is required
  </mat-error>


</div>
}